module.exports = __webpack_public_path__ + "static/flags/RU-5d3223feb84877ef409a9c0ca92fb672.gif";